import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const OpticksIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-opticks${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
  >
    <title>Opticks</title>
    <rect
      x="9.75964"
      y="6.72218"
      width="0.6105"
      height="2.5234"
      rx="0.30525"
      fill="#21CDB0"
    />
    <rect
      x="11.2655"
      y="5.81322"
      width="0.6105"
      height="2.61837"
      rx="0.30525"
      fill="#21CDB0"
    />
    <rect
      x="12.7714"
      y="4.89067"
      width="0.6105"
      height="6.19997"
      rx="0.30525"
      fill="#21CDB0"
    />
    <rect
      x="6.12378"
      y="6.73575"
      width="0.6105"
      height="5.99647"
      rx="0.30525"
      fill="#21CDB0"
    />
    <rect
      x="4.61786"
      y="5.81322"
      width="0.6105"
      height="6.07787"
      rx="0.30525"
      fill="#21CDB0"
    />
    <rect
      x="3.11194"
      y="4.93138"
      width="0.6105"
      height="6.1457"
      rx="0.30525"
      fill="#21CDB0"
    />
    <rect
      x="4.87146"
      y="4.39868"
      width="0.625782"
      height="6.11639"
      rx="0.312891"
      transform="rotate(-60 4.87146 4.39868)"
      fill="#21CDB0"
    />
    <rect
      x="6.09662"
      y="9.20416"
      width="0.625782"
      height="2.61362"
      rx="0.312891"
      transform="rotate(-60 6.09662 9.20416)"
      fill="#21CDB0"
    />
    <rect
      x="6.09686"
      y="10.9543"
      width="0.625782"
      height="2.61918"
      rx="0.312891"
      transform="rotate(-60 6.09686 10.9543)"
      fill="#21CDB0"
    />
    <rect
      x="3.00342"
      y="10.9048"
      width="0.625782"
      height="6.18675"
      rx="0.312891"
      transform="rotate(-60 3.00342 10.9048)"
      fill="#21CDB0"
    />
    <rect
      x="6.40051"
      y="3.49258"
      width="0.625782"
      height="6.09084"
      rx="0.312891"
      transform="rotate(-60 6.40051 3.49258)"
      fill="#21CDB0"
    />
    <rect
      x="7.84772"
      y="2.54189"
      width="0.625782"
      height="6.16171"
      rx="0.312891"
      transform="rotate(-60 7.84772 2.54189)"
      fill="#21CDB0"
    />
    <rect
      x="8.37408"
      y="2.00029"
      width="0.625782"
      height="6.20551"
      rx="0.312891"
      transform="rotate(60 8.37408 2.00029)"
      fill="#21CDB0"
    />
    <rect
      x="13.1817"
      y="10.3653"
      width="0.625782"
      height="6.18536"
      rx="0.312891"
      transform="rotate(60 13.1817 10.3653)"
      fill="#21CDB0"
    />
    <rect
      x="13.1377"
      y="8.65419"
      width="0.625782"
      height="6.13456"
      rx="0.312891"
      transform="rotate(60 13.1377 8.65419)"
      fill="#21CDB0"
    />
    <rect
      x="13.1406"
      y="6.89854"
      width="0.625782"
      height="6.14175"
      rx="0.312891"
      transform="rotate(60 13.1406 6.89854)"
      fill="#21CDB0"
    />
    <rect
      x="8.26141"
      y="5.61929"
      width="0.625782"
      height="2.59731"
      rx="0.312891"
      transform="rotate(60 8.26141 5.61929)"
      fill="#21CDB0"
    />
    <rect
      x="6.66144"
      y="4.76108"
      width="0.625782"
      height="2.48929"
      rx="0.312891"
      transform="rotate(60 6.66144 4.76108)"
      fill="#21CDB0"
    />
  </OpticksSvgElement>
);

export default OpticksIcon;
